<template>
    <Modal class="payment-token-selection-modal"
           title="PAYMENT.TOKEN_MODAL_TITLE"
           icon="fa-credit-card"
           :ok="ok"
           :cancel="cancel">
        <div class="payment-tokens">
            <a v-for="token in tokens"
               :key="token.ID"
               class="btn btn-block btn-lg text-left"
               :class="[selectedToken === token ? 'active btn-info' : 'btn-default']"
               @click.prevent="selectToken(token)">
                <img v-if="token.cardTypeRef"
                     :src="'/epos/img/card-types/' + token.cardTypeRef + '.png'"
                     class="card-type-logo"
                     :alt="token.cardType" />
                {{ token.reference }}
            </a>
        </div>
    </Modal>
</template>

<script>
import Modal from '@/vue/components/Modals/Modal';
import { ModalPropsMixin } from '@/vue/mixins/ModalPropsMixin';

export default {
    components: { Modal },

    mixins: [
        ModalPropsMixin,
    ],

    props: {
        tokens: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            selectedToken: null,
        };
    },

    methods: {
        /**
         * @param {PaymentToken} token
         */
        selectToken(token) {
            if (this.selectedToken === token) {
                this.selectedToken = null;
            } else {
                this.selectedToken = token;
            }
        },

        ok() {
            this.resolve({
                token: this.selectedToken,
            });
        },
    },
};
</script>
